import { FC, useMemo, useState } from 'react'
import { CONFIG } from '../../../config'
import { IImport } from '../../../model/IImport'
import { icons, IIconOptions } from '../../icons/IconSet'
import { getTimeDiffString } from '../../utils/getTimeDiff'
import parseISOToDate from '../../utils/ParseISOtoDate'
import Modal from '../common/Modal'
import TableTd from '../common/table/TableTd'
import TableTr from '../common/table/TableTr'
import Truncate from '../Truncate'
import RepeatImport from './RepeatImport'

const ImportsRow: FC<{ imprt: IImport }> = ({ imprt }) => {
  const [isModal, setIsModal] = useState<boolean>(false)

  const iconsOptions: IIconOptions = useMemo(
    () => ({
      stroke:
        {
          0: '',
          1: '',
          2: 'green',
          3: 'red',
          4: 'green',
        }?.[imprt?.status] || 'black',
      width: '1.5em',
    }),
    [imprt?.status],
  )

  return (
    <TableTr
      className={`
      ${
        {
          0: '',
          1: ' bg-orange-200 animate-pulse',
          2: ' bg-green-100 text-green-950',
          3: 'bg-red-50 text-red-950',
          4: ' bg-green-50 text-green-950',
        }?.[imprt.status] || ''
      }
    `}
    >
      <TableTd align='center'>{CONFIG.importTypes?.[imprt.status]}</TableTd>

      {/* <TableTd align='center'>{imprt.goalServer}</TableTd> */}

      <TableTd align='center'>
        <div className=' whitespace-nowrap'>{imprt.productId}</div>
      </TableTd>

      <TableTd align='center'>
        <div className='whitespace-nowrap'>
          {!imprt.proccessPeriodMs
            ? '-'
            : getTimeDiffString({
                startDate: new Date(+new Date() - imprt.proccessPeriodMs),
                isAccuracy: true,
              })}
        </div>
      </TableTd>

      <TableTd align='center'>
        <Truncate>{imprt.productName}</Truncate>
      </TableTd>

      <TableTd align='center'>
        {!!imprt?.isImprtRewriteImages && (
          <div title='Replace images when updating the product'>
            {icons('image-down', { ...iconsOptions, width: '1.2em' })}
          </div>
        )}
      </TableTd>

      <TableTd align='center'>{imprt.company}</TableTd>

      {/* <TableTd align="center">
        {imprt.priceType}
      </TableTd>

      <TableTd align="center">
        {imprt.configurationType}
      </TableTd> */}

      <TableTd align='center'>
        <div className=' whitespace-nowrap'>
          {imprt.createdAt && getTimeDiffString({ startDate: parseISOToDate(imprt.createdAt) })}
        </div>
      </TableTd>

      <TableTd align='center'>
        <div className='whitespace-nowrap'>
          {imprt.sendedAt && getTimeDiffString({ startDate: parseISOToDate(imprt.sendedAt) })}
        </div>
      </TableTd>

      <TableTd align='center'>
        <Truncate>{imprt?.error}</Truncate>
      </TableTd>

      <TableTd
        align='center'
        className='flex items-center justify-end'
      >
        {!!imprt?.log && (
          <>
            <div
              tabIndex={-1}
              role='button'
              onClick={() => setIsModal(() => true)}
              className='opacity-60 hover:opacity-100 transition-all'
            >
              {icons('message-square-text', iconsOptions)}
            </div>

            {!!isModal && (
              <Modal
                title={`Log of Product #${imprt.productId}`}
                style={{ maxWidth: '1000px' }}
                onClose={() => setIsModal(() => false)}
              >
                <div dangerouslySetInnerHTML={{ __html: imprt.log }} />
              </Modal>
            )}
          </>
        )}

        <RepeatImport
          imprt={imprt}
          className='ml-2'
        >
          {icons('undo-2', iconsOptions)}
        </RepeatImport>
      </TableTd>
    </TableTr>
  )
}

export default ImportsRow
